"use client";

import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { HeroVorgangShell } from "./hero-vorgang-shell";
import {
  type HeroVorgangConversationId,
  getVorgangById,
} from "./module-inbox-vorgang-data";

export function ModuleInboxVorgangDetail(props: {
  readonly conversationId: HeroVorgangConversationId;
  readonly onBack: () => void;
}): ReactNode {
  const tModuleInboxVorgangData = useTranslations(
    "marketing.moduleInboxVorgangData",
  );
  const fixture = getVorgangById(tModuleInboxVorgangData, props.conversationId);
  if (fixture === null) return null;

  return <HeroVorgangShell fixture={fixture} onBack={props.onBack} />;
}
